export const c_skeleton_Height = {
  "name": "--pf-v5-c-skeleton--Height",
  "value": "calc(0.875rem * 1.5)",
  "var": "var(--pf-v5-c-skeleton--Height)"
};
export default c_skeleton_Height;